<template>
  <roles-and-privileges-settings />
</template>

<script>
import RolesAndPrivilegesSettings from "@/components/3pl/Settings/RolesAndPrivileges/index";
export default {
  components: {
    RolesAndPrivilegesSettings,
  },
};
</script>

<style></style>
